const INITIAL_STATE = {
  data: {},
  errors: {},
}
const getWorkOrdersSummary = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_WORK_ORDERS_SUMMARY_SUCCESSFULLY':
	  return { ...INITIAL_STATE, data: action.data }
  case 'GET_WORK_ORDERS_SUMMARY_FAILED':
	  return { ...INITIAL_STATE, errors: action.data }
  default:
	  return { ...state }
  }
};
		
export default getWorkOrdersSummary;